import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      background: '#E4E4E4',
      marginTop: 0,
      padding: '0.5rem',
      borderRadius: 2,
      height: 322,
      overflowY: 'auto',
    },
  }),
)
